"use strict";
export const DEFAULT_ROUTE_SOURCES = {
  v2: true,
  v3: true,
  topazApi: true,
  zeroX: true,
  openOcean: false,
  binance: true
};
export function resolveRouteSources(sources) {
  return { ...DEFAULT_ROUTE_SOURCES, ...sources ?? {} };
}
const AGGREGATOR_TOKEN_BLOCKLIST = {
  // The phantom-quote failure mode above cannot apply here — this IS Topaz direct,
  // quoted by Topaz's own quoters. The slot exists so a token the API misprices for a
  // different reason (e.g. a fee-on-transfer token, which its quoters do not model)
  // can be excluded in one line instead of rediscovering this gate.
  topazApi: /* @__PURE__ */ new Set(),
  // Quotes the 44 token below Topaz direct, so it cannot falsely win it.
  zeroX: /* @__PURE__ */ new Set(),
  openOcean: /* @__PURE__ */ new Set([
    // 44 token — still returns the raw pool output with zero fee deducted.
    "0x444446d6c6d1a4777d26b7746ea240ed0cc44444"
  ]),
  // Empty on measurement, not assumption: Binance quotes the 44 token 1.58% below Topaz
  // direct, so it can never win it on a phantom number. Denying a route that prices
  // itself honestly would just cost users the fills it legitimately wins elsewhere.
  binance: /* @__PURE__ */ new Set()
};
export function isAggregatorBlockedForTokens(source, ...tokenAddresses) {
  const blocklist = AGGREGATOR_TOKEN_BLOCKLIST[source];
  if (blocklist.size === 0) {
    return false;
  }
  return tokenAddresses.some((address) => address && blocklist.has(address.toLowerCase()));
}
